<script setup>
import NextButton from 'dashboard/components-next/button/Button.vue';

import { rulesContent } from '../../helpers/kraftchatAIRulesConfig';

defineProps({
  title: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    default: '',
  },
  summary: {
    type: String,
    default: '',
  },
  isOpen: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['toggle']);
</script>

<template>
  <section class="rounded-xl border border-n-weak bg-n-background p-4">
    <div
      class="flex flex-col gap-3 md:flex-row md:items-start md:justify-between"
    >
      <div class="min-w-0 space-y-1">
        <div class="flex flex-wrap items-center gap-2">
          <h3 class="text-sm font-semibold text-n-slate-12">
            {{ title }}
          </h3>

          <span
            v-if="summary"
            class="rounded-md bg-n-alpha-1 px-2 py-0.5 text-xs font-medium text-n-slate-11"
          >
            {{ summary }}
          </span>
        </div>

        <p v-if="description" class="text-sm leading-6 text-n-slate-11">
          {{ description }}
        </p>
      </div>

      <NextButton
        type="button"
        outline
        slate
        size="sm"
        :label="isOpen ? rulesContent.closeLabel : rulesContent.configureLabel"
        @click="emit('toggle')"
      />
    </div>

    <div v-if="isOpen" class="mt-4 border-t border-n-weak pt-4">
      <slot />
    </div>
  </section>
</template>
